import React from 'react';
import { Reveal } from './Reveal';
import { kitContents } from '../data/kitContents';
export function KitContentsSection() {
  return <section className="bg-brand-sandSoft px-4 py-20 md:py-28" data-id="element-107" data-mp="209o2oa1qn9ku">
      <Reveal className="mx-auto max-w-5xl" data-id="element-108" data-mp="257ze2p7ols56">
        <div className="mb-12 text-center" data-id="element-109" data-mp="256xt9t0v5ra9">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-sageInk" data-id="element-110" data-mp="2a7v8bwqku57j">CE QUE CONTIENT LE PACK</p>
          <h2 className="text-3xl font-black text-brand-slate md:text-4xl" data-id="element-111" data-mp="2f5dj7so5mui6">
            Que contient le pack Pilates Reformer Prêt™️ ?
          </h2>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-112" data-mp="2nyqh7912smb4">
          {kitContents.map(({
          icon: ContentIcon,
          title,
          description
        }) => <article key={title} className="flex flex-col rounded-2xl border border-brand-sand bg-white p-7 text-center" data-id="element-113" data-mp="2swibg9p70kih">
              <ContentIcon className="mx-auto h-8 w-8 text-brand-sage" strokeWidth={1.5} aria-hidden="true" data-id="element-114" data-mp="32vra3fv06nb6" />
              <h3 className="mt-5 text-xl font-bold text-brand-slate" data-id="element-115" data-mp="10m5ixx0vmdmg">{title}</h3>
              <p className="mt-2 text-sm text-brand-gray" data-id="element-116" data-mp="vmsvba26l2it">{description}</p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}